// Compare uniqueness of two inputs
export function CompareToUniqueDirective() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function (scope, element, attrs, ngModel) {
      scope.$watch(attrs.compareToUnique, function () {
        ngModel.$validate();
      });

      ngModel.$validators.unique = function (modelValue) {
        var compareToUnique = scope.$eval(attrs.compareToUnique);
        if (!modelValue || !compareToUnique) {
          // Both values must be entered
          return;
        }

        var compareField = scope.$eval(attrs.compareField);

        modelValue = compareField ? modelValue[compareField] : modelValue;

        compareToUnique = compareField ? compareToUnique[compareField] : compareToUnique;

        return modelValue !== compareToUnique;
      };
    },
  };
}
